angular.module('moebiusProadapt').controller('ctrlNavBar',
    ['$scope', '$http', '$location', function($scope, $http, $location){
        $scope.isActiveRoute = function(value){


            var searchPattern = new RegExp('^/' + value, 'i');
            return searchPattern.test($location.path());


            // return !!$location.path().match(value);
        }

    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/navbar.js